'use strict';

var badge = require('../../../../../../../../../../_virtual/badge.cjs');

(function (exports) {

	exports.BADGE_COLORS = void 0;
	(function(BADGE_COLORS) {
	    BADGE_COLORS["success"] = "success";
	    BADGE_COLORS["system"] = "system";
	    BADGE_COLORS["danger"] = "danger";
	    BADGE_COLORS["light"] = "light";
	})(exports.BADGE_COLORS || (exports.BADGE_COLORS = {}));
	
} (badge.__exports));
//# sourceMappingURL=badge.cjs.map
